<template>
    <div class="msg-lightbox"
         data-cy="attachment-lightbox"
         role="dialog"
         aria-modal="true"
         :aria-label="current.name"
         tabindex="-1"
         ref="root"
         @click.self="$emit('close')"
         @keydown.esc.stop="$emit('close')"
         @keydown.left.stop="prev"
         @keydown.right.stop="next"
         @touchstart="onTouchStart"
         @touchend="onTouchEnd">

        <div class="msg-lightbox__bar">
            <span class="msg-lightbox__name">{{ current.name }}</span>
            <span v-if="images.length > 1" class="msg-lightbox__count">{{ index + 1 }} / {{ images.length }}</span>
            <a class="msg-lightbox__btn"
               :href="href"
               target="_blank"
               rel="noopener"
               title="Open in a new tab"
               aria-label="Open in a new tab"
               @click.stop>
                <i class="fa-solid fa-up-right-from-square" aria-hidden="true"></i>
            </a>
            <button type="button"
                    class="msg-lightbox__btn"
                    title="Close"
                    aria-label="Close"
                    @click="$emit('close')">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
        </div>

        <button v-if="images.length > 1"
                type="button"
                class="msg-lightbox__nav msg-lightbox__nav--prev"
                aria-label="Previous image"
                @click.stop="prev">
            <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
        </button>

        <img class="msg-lightbox__img" :src="srcFor(current)" :alt="current.name" @click.stop />

        <button v-if="images.length > 1"
                type="button"
                class="msg-lightbox__nav msg-lightbox__nav--next"
                aria-label="Next image"
                @click.stop="next">
            <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
// Horizontal travel before a touch counts as a swipe rather than a tap or a
// vertical scroll attempt.
const SWIPE_THRESHOLD = 40;

export default {
  name: 'attachment-lightbox',
  props: {
    images: { type: Array, required: true },
    startIndex: { type: Number, default: 0 },
  },
  data() {
    return {
      index: this.startIndex,
      touchStartX: null,
      touchStartY: null,
    };
  },
  computed: {
    current() {
      return this.images[this.index] || {};
    },
    href() {
      return this.srcFor(this.current);
    },
  },
  mounted() {
    // Focus the dialog so the arrow/esc keydown handlers receive keys without
    // the user having to click first, and so the chat transcript behind us does
    // not scroll on arrow presses.
    if (this.$refs.root) this.$refs.root.focus();
    document.body.classList.add('composer-overlay-open');
  },
  destroyed() {
    document.body.classList.remove('composer-overlay-open');
  },
  methods: {
    srcFor(image) {
      return image.url ? decodeURI(image.url) : '';
    },
    prev() {
      this.index = (this.index - 1 + this.images.length) % this.images.length;
    },
    next() {
      this.index = (this.index + 1) % this.images.length;
    },
    onTouchStart(event) {
      const touch = event.changedTouches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    },
    // Swipe is the only way to move between images on touch, where the arrows
    // are hidden as a redundant affordance sitting on top of the photo.
    onTouchEnd(event) {
      if (this.touchStartX === null || this.images.length < 2) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - this.touchStartX;
      const dy = touch.clientY - this.touchStartY;
      this.touchStartX = null;
      this.touchStartY = null;

      // Ignore mostly-vertical drags so a scroll gesture does not flip images.
      if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) this.next();
      else this.prev();
    },
  },
};
</script>
